import { Injectable } from '@angular/core';
import axios from 'axios';

import { getLocalStorage, setLocalStorage } from '../utils/storage';
import { LoaderService } from './loader.service';
import { AuthService } from './auth.service';
import { keyStorage } from '../constants/storage';
import { checkExpiredToken } from '../utils/utilityFunction';
import { HttpRequestService } from './http-request.service';
import { apiUrl } from '../constants/apiUrl';
import { FunctionListenerService } from './function-listener.service';

const TOKEN_ERROR_CODE = {
    INVALID_REFRESH_TOKEN: 'INVALID_REFRESH_TOKEN',
    EXPIRED_REFRESH_TOKEN: 'EXPIRED_REFRESH_TOKEN',
    INVALID_REFRESH_TOKEN_OR_EXPIRED: 'INVALID_REFRESH_TOKEN_OR_EXPIRED',
};
@Injectable({
    providedIn: 'root',
})
export class AxiosListenerService {
    inUsedToken = null;
    orderCounter = 0;
    constructor(
        private authService: AuthService,
        private httpService: HttpRequestService,
        private loaderService: LoaderService,
        private funcListenerService: FunctionListenerService 
    ) {}
    async subscribeAxios() {

        this.httpService.getIP();

        axios.interceptors.request.use(async (request) => {
            let newRequest = { ...request };

            newRequest.headers = { ...this.createNewHeader(request.headers) };

            if (newRequest.headers.Authorization) {
                let bearer = `${newRequest.headers.Authorization}`;
                let encryptToken = bearer.split('Bearer ')[1];
                let isTokenExpired = checkExpiredToken(encryptToken);
                let refreshToken = getLocalStorage(keyStorage.refreshToken);

                /** Retry Service */
                this.inUsedToken = refreshToken;
                if (
                    isTokenExpired &&
                    refreshToken &&
                    this.inUsedToken !== refreshToken
                ) {
                    this.orderCounter += 1;
                    await this.renewToken(refreshToken);
                    newRequest.headers.Authorization = `Bearer ${getLocalStorage(
                        keyStorage.accessToken
                    )}`;
                    this.inUsedToken = null;
                    if (this.orderCounter > 0) {
                        this.orderCounter = this.orderCounter - 1;
                    }
                } else if (
                    isTokenExpired &&
                    refreshToken &&
                    this.inUsedToken === refreshToken
                ) {
                    this.orderCounter += 1;
                    await new Promise((resolve) => {
                        const timerVal = this.orderCounter * 4000;
                        setTimeout(async () => {
                            if (checkExpiredToken(encryptToken)) {
                                await this.renewToken(
                                    getLocalStorage(keyStorage.refreshToken)
                                );
                            } else {
                                newRequest.headers.Authorization = `Bearer ${getLocalStorage(
                                    keyStorage.accessToken
                                )}`;
                            }
                            resolve('RE-TOKEN');
                        }, timerVal);
                    });
                    if (this.orderCounter > 0) {
                        this.orderCounter = this.orderCounter - 1;
                    }
                }
            }
            return newRequest;
        });

        axios.interceptors.response.use(
            (response) => {
                return response;
            },
            async (error) => {
                if (this.loaderService.getIsLoading() && !this.loaderService.getIsHolding()) {
                    this.loaderService.hideLoader();
                }
                console.log('>>', error);

                if (error?.response?.status === 401 && error.response.config) {
                    const isInvalidToken: boolean =
                        error?.response?.data?.errorCode ===
                            TOKEN_ERROR_CODE.INVALID_REFRESH_TOKEN ||
                        error?.response?.data?.errorCode ===
                            TOKEN_ERROR_CODE.INVALID_REFRESH_TOKEN_OR_EXPIRED;
                    if (isInvalidToken) {
                        // alert('Invalid Token');
                        this.authService.goToLoginPage();
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    async renewToken(refreshToken: string) {
        await this.httpService
            .axiosGet(`${apiUrl.getToken}?refreshToken=${refreshToken}`)
            .then((response) => {
                setLocalStorage(
                    keyStorage.accessToken,
                    response.data.accessToken
                );
                setLocalStorage(
                    keyStorage.refreshToken,
                    response.data.refreshToken
                );
            });
    }

    createNewHeader(headers: any) {
        const currentFuncId = this.funcListenerService.getCurrentFunctionId() ?? undefined;
        const currentIpAddress = getLocalStorage(keyStorage.address);
        let newHeaders = { ...headers };
        if (currentFuncId) {
            newHeaders = {
                ...newHeaders,
                function_id: currentFuncId,
            }
        }

        if (currentIpAddress) {
            newHeaders = {
                ...newHeaders,
                ip_address: currentIpAddress
            }
        }

        return newHeaders;
    }
}
